import classNames from 'classnames';
import { ForwardedRef, ReactNode } from 'react';

import styles from '../../styles/themes/cfpbj.module.css';

interface CfpbjThemeProps {
    className?: string | null;
    ref?: ForwardedRef<HTMLDivElement> | null;
    children: ReactNode;
    [key: string]: unknown;
}

function CfpbjTheme({ children, className = null, ref = null, ...props }: CfpbjThemeProps) {
    return (
        <div className={classNames([className, styles.container])} ref={ref} {...props}>
            {children}
        </div>
    );
}

export default CfpbjTheme;
